import React from 'react';

const FilteredResults = ({ dealers }) => (
  <div className="grid grid--gutter">
    {dealers.map(
      (
        {
          title,
          address_line_1,
          address_line_2,
          city,
          state,
          zip_code,
          website,
          phone,
        },
        key
      ) => (
        <div
          key={key}
          className="grid__col-xs-12 grid__col-sm-6 grid__col-md-4"
        >
          <article className="card card--callout">
            <section className="card__body u--padding-0">
              <h3 className="h5">{title}</h3>
              <p>
                {address_line_1}
                {address_line_2 && ', ' + address_line_2}
                <br />
                {city}, {state} {zip_code}
                <br />
                <a
                  href={`https://${website}`}
                  title={`Visit: ${title}`}
                  target="_blank"
                  rel="noopener"
                >
                  {website}
                </a>
                <br />
                <a
                  href={`tel:${phone}`}
                  title={`Call: ${phone}`}
                  target="_blank"
                  rel="noopener"
                >
                  {phone}
                </a>
              </p>
            </section>
          </article>
        </div>
      )
    )}
  </div>
);

export default FilteredResults;
